import { render, staticRenderFns } from "./headbar.vue?vue&type=template&id=4a50793c&scoped=true&"
import script from "./headbar.vue?vue&type=script&lang=js&"
export * from "./headbar.vue?vue&type=script&lang=js&"
import style0 from "./headbar.vue?vue&type=style&index=0&id=4a50793c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a50793c",
  null
  
)

export default component.exports